import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { StorageService } from "@app/services/storage.service";

@NgFilter({
    token: Token.QuoteProductImageFilter,
    dependencies: [
        Token.StorageService
    ]
})
export class QuoteProductImageFilter {
    constructor(
        storageService: StorageService
    ) {
        return ((relativePath: string) => {
            if (!relativePath) {
                return storageService.getFallbackImage();
            } else if (relativePath.startsWith("media/") || relativePath.startsWith("productimages/")) {
                // if it's a media file, go straight to the blob storage to spare the round trip and redirect
                return storageService.getFileUrl(relativePath);
            } else {
                return "/api/" + relativePath;
            }
        }) as any;
    }

}
